'use client';
function keys(object) {
  return Object.keys(object);
}

export { keys };
//# sourceMappingURL=keys.mjs.map
